module.exports = __webpack_public_path__ + "9c26f60a63bf575c6b7be3eec11e3043.svg";